import React, { ReactElement, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";
import AppModal from "components/shared/modal/AppModal";

import { getDatabaseConfig, postEditDatabaseConfig } from "redux/handlers/webAppHandler";

import { useAppDispatch } from "hooks/reduxHook";

import { IDatabaseConfigData } from "types/api/webAppApiInterface";

const ChangeDbConfig = ({ id, type }: { id: number; type: string }): ReactElement => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const [open, setOpen] = useState<boolean>(false);
 const [loading, setLoading] = useState<boolean>(false);
 const [parameter, setParameter] = useState<string>("");
 const [value, setValue] = useState<string | number>("");
 const [parameterList, setParameterList] = useState<Array<string>>([]);
 const [configData, setConfigData] = useState<Array<IDatabaseConfigData>>([]);

 const handleOpen = async () => {
  const datas = await dispatch(getDatabaseConfig(type));
  let paramsList: Array<string> = [];
  datas.map((element) => paramsList.push(element.name));
  setParameterList(paramsList);
  setConfigData(datas);
  setOpen(true);
 };
 const handleClose = () => setOpen(false);

 const handleConfirm = async () => {
  setLoading(true);
  await dispatch(postEditDatabaseConfig(id, parameter, value));
  setLoading(false);
  handleClose();
 };

 return (
  <>
   <Tooltip title={<FormattedMessage id="docker.website.changeDbConfig" />}>
    <IconButton onClick={() => handleOpen()}>
     <IconSelector icon="ServiceIcon" props={{ color: "kxOrange" }} />
    </IconButton>
   </Tooltip>
   <AppModal
    open={open}
    close={handleClose}
    title={intl.formatMessage({ id: "docker.website.changeDbConfig" })}
    handleClose={handleClose}
    handleConfirm={handleConfirm}
    disabled={loading || parameter === "" || value === "" || value === 0}>
    <Stack spacing={2}>
     <Typography variant="subtitle2">
      <FormattedMessage id="docker.website.changeDbConfigMessage" />
     </Typography>
     <FormControl>
      <InputLabel>
       <FormattedMessage id="docker.website.changeDbConfigParameter" />
      </InputLabel>
      <Select
       value={parameter}
       label={<FormattedMessage id="docker.website.changeDbConfigParameter" />}
       onChange={(e) => setParameter(e.target.value)}>
       {parameterList.map((element, index) => {
        return (
         <MenuItem key={`parameter-${index}`} value={element}>
          {element}
         </MenuItem>
        );
       })}
      </Select>
     </FormControl>
     <FormControl>
      <InputLabel>
       <FormattedMessage id="docker.website.changeDbConfigValue" />
      </InputLabel>
      <Select
       value={value}
       disabled={parameter === ""}
       label={<FormattedMessage id="docker.website.changeDbConfigValue" />}
       onChange={(e) => setValue(e.target.value)}>
       {configData
        .find((element) => element.name === parameter)
        ?.parameters.map((element, index) => {
         return (
          <MenuItem key={`params-value-${index}`} value={element}>
           {element}
          </MenuItem>
         );
        })}
      </Select>
     </FormControl>
    </Stack>
   </AppModal>
  </>
 );
};

export default ChangeDbConfig;
